import gladalleLogo from '../assets/img/franchises/GLaDalle.jpg';
import dominosLogo from '../assets/img/franchises/dominos.png';
import subwayLogo from '../assets/img/franchises/subway.png';
import oTacosLogo from '../assets/img/franchises/otacos.webp';
import shakeBeefLogo from '../assets/img/franchises/shakebeef.png';
import fiveGuysLogo from '../assets/img/franchises/fiveguys.png';
import popeyesLogo from '../assets/img/franchises/popeyes.png';
import mcdoLogo from '../assets/img/franchises/mcdo.png';
import QuickLogo from '../assets/img/franchises/QuickLogo.png';
import BurgerKingLogo from '../assets/img/franchises/BurgerKingLogo.png';
import BillsBurgerLogo from '../assets/img/franchises/billsBurgerLogo.png';
import KFCLogo from '../assets/img/franchises/KFC.png';

interface FranchiseMatch {
    name: string;
    logo: string | React.ComponentType;
    isIcon?: boolean;
}

const franchiseLogos: Record<string, { logo: string | React.ComponentType; isIcon?: boolean }> = {
    'gladalle': { logo: gladalleLogo },
    'mc donald\'s': { logo: mcdoLogo },
    'MC DONALD\'S': { logo: mcdoLogo },
    'mcdo': { logo: mcdoLogo },
    "MCDONALD'S": { logo: mcdoLogo },
    'McDonald\'s': { logo: mcdoLogo },
    'g la dalle': { logo: gladalleLogo },
    'dominos': { logo: dominosLogo },
    'domino\'s': { logo: dominosLogo },
    'subway': { logo: subwayLogo },
    'o\'tacos': { logo: oTacosLogo },
    'otacos': { logo: oTacosLogo },
    'shakebeef': { logo: shakeBeefLogo },
    'shake beef': { logo: shakeBeefLogo },
    'five guys': { logo: fiveGuysLogo },
    '5 guys': { logo: fiveGuysLogo },
    'popeyes': { logo: popeyesLogo },
    'quick': { logo: QuickLogo },
    'burger king': { logo: BurgerKingLogo },
    'bills burger': { logo: BillsBurgerLogo },
    'kfc': { logo: KFCLogo },
    'kentucky fried chicken': { logo: KFCLogo },
    'KFC': { logo: KFCLogo },
};

// Emoji fallbacks for restaurant types
const restaurantTypeEmojis: Record<string, string> = {
    // Pizza
    'pizza': '🍕',
    'pizzeria': '🍕',
    'del arte': '🍕',

    // Kebab & Middle Eastern
    'kebab': '🌯',
    'doner': '🌯',
    'döner': '🌯',
    'shawarma': '🌯',
    'falafel': '🧆',
    'hummus': '🧆',
    'mezze': '🧆',
    'libanais': '🧆',
    'lebanese': '🧆',

    // Coffee & Cafe
    'coffee': '☕',
    'cafe': '☕',
    'café': '☕',
    'espresso': '☕',
    'starbucks': '☕',
    'brunch': '☕',
    'tea': '🍵',
    'thé': '🍵',

    // Burger
    'burger': '🍔',
    'hamburger': '🍔',
    'smash': '🍔',

    // Hot dog
    'hot dog': '🌭',
    'hotdog': '🌭',

    // Tacos & Mexican
    'taco': '🌮',
    'tacos': '🌮',
    'mexican': '🌮',
    'mexique': '🌮',
    'burrito': '🌯',
    'wrap': '🌯',

    // Sushi & Japanese
    'sushi': '🍣',
    'japonais': '🍱',
    'japanese': '🍱',
    'japon': '🍱',
    'bento': '🍱',
    'teriyaki': '🍱',

    // Ramen & Noodles
    'ramen': '🍜',
    'noodle': '🍜',
    'pho': '🍜',
    'vietnamese': '🍜',
    'vietnamien': '🍜',
    'banh mi': '🥖',

    // Asian generic
    'asian': '🥡',
    'chinese': '🥡',
    'chinois': '🥡',
    'wok': '🥡',
    'thai': '🍜',
    'thaï': '🍜',

    // Korean
    'korean': '🍱',
    'coréen': '🍱',
    'coreen': '🍱',

    // Indian
    'indian': '🍛',
    'indien': '🍛',
    'curry': '🍛',
    'tandoor': '🍛',
    'india': '🍛',

    // Poke & Bowls
    'poke': '🥗',
    'bowl': '🥗',

    // Chicken
    'chicken': '🍗',
    'kfc': '🍗',
    'poulet': '🍗',

    // Friterie
    'friterie': '🍟',
    'frite': '🍟',
    'frites': '🍟',

    // Sandwich & Deli
    'sandwich': '🥪',
    'deli': '🥪',
    'traiteur': '🥪',
    'sub': '🥪',

    // Bakery & Pastry
    'bakery': '🥐',
    'boulangerie': '🥐',
    'viennoiserie': '🥐',
    'patisserie': '🧁',
    'pâtisserie': '🧁',
    'pastry': '🧁',
    'donut': '🍩',
    'waffle': '🧇',
    'gaufre': '🧇',

    // Ice cream & Desserts
    'ice cream': '🍦',
    'gelato': '🍦',
    'glacier': '🍦',
    'glace': '🍦',
    'dessert': '🍰',
    'chocolat': '🍫',

    // Crepes
    'crepes': '🥞',
    'crêpes': '🥞',
    'creperie': '🥞',
    'crêperie': '🥞',
    'pancake': '🥞',

    // Steak & Grill
    'steak': '🥩',
    'grill': '🥩',
    'bbq': '🥩',
    'barbecue': '🥩',
    'boucherie': '🥩',
    'viande': '🥩',

    // Fast food generic
    'fast food': '🍟',
    'fastfood': '🍟',

    // Seafood
    'seafood': '🦞',
    'poisson': '🐟',
    'fish': '🐟',
    'saumon': '🐟',
    'oyster': '🦪',
    'huitre': '🦪',
    'huître': '🦪',
    'fruits de mer': '🦞',

    // Pasta & Italian
    'pasta': '🍝',
    'italian': '🍝',
    'italien': '🍝',
    'napilitan': '🍝',
    'napoli': '🍝',
    'italie': '🍝',
    'pates': '🍝',
    'pâtes': '🍝',
    'trattoria': '🍝',
    'osteria': '🍝',

    // Greek
    'greek': '🫒',
    'grec': '🫒',
    'gyros': '🫒',
    'souvlaki': '🫒',

    // Moroccan / North African
    'marocain': '🫕',
    'moroccan': '🫕',
    'couscous': '🫕',
    'tajine': '🫕',
    'tagine': '🫕',

    // Spanish
    'tapas': '🥘',
    'paella': '🥘',
    'espagnol': '🥘',

    // Healthy/Salad/Vegan
    'salad': '🥗',
    'salade': '🥗',
    'healthy': '🥗',
    'vegan': '🥗',
    'végétalien': '🥗',
    'vegetarian': '🥗',
    'végétarien': '🥗',
    'bio': '🌿',
    'smoothie': '🥤',
    'juice': '🥤',
    'jus': '🥤',

    // Bar & Drinks
    'bar': '🍺',
    'pub': '🍺',
    'brasserie': '🍺',
    'taverne': '🍺',
    'wine': '🍷',
    'vin': '🍷',
    'cave': '🍷',
    'cocktail': '🍸',

    // Bistro & French
    'bistro': '🍽️',
    'bistrot': '🍽️',
    'auberge': '🍽️',
    'hostellerie': '🍽️',
    'terroir': '🍽️',
    'gastronomie': '🍽️',
    'gastronomique': '🍽️',
    'brasserie restaurant': '🍽️',

    // Generic restaurant
    'restaurant': '🍽️',
    'resto': '🍽️',
    'table': '🍽️',
    'relais': '🍽️',
    'chez': '🍽️',
    'rendez-vous': '🍽️',
    'restaurations': '🍽️',
    'bouche': '🍽️',
    'épicerie': '🛒',
    'epicerie': '🛒',
};

// NAF code → emoji for activity types not covered by name keywords
const nafCodeEmojis: Record<string, string> = {
    '1071': '🥐', // Boulangerie-pâtisserie
};

function getEmojiFromNaf(nafCode?: string): string | null {
    if (!nafCode) return null;
    const normalized = nafCode.replace(/\./g, '').toUpperCase().slice(0, 4);
    return nafCodeEmojis[normalized] ?? null;
}

/**
 * Detects if a company name matches a known franchise
 * @param companyName - The company name to check
 * @param nafCode - Optional NAF code for activity-based emoji override
 * @returns FranchiseMatch object if franchise detected, null otherwise
 */
export const detectFranchise = (companyName: string, nafCode?: string): FranchiseMatch | null => {
    if (!companyName) return null;

    const normalizedName = companyName.toLowerCase().trim();

    // First, check for exact franchise matches (priority)
    for (const [franchiseName, config] of Object.entries(franchiseLogos)) {
        if (normalizedName.includes(franchiseName)) {
            return {
                name: franchiseName,
                logo: config.logo,
                isIcon: config.isIcon
            };
        }
    }

    // NAF code takes priority over name-based emoji fallbacks
    const nafEmoji = getEmojiFromNaf(nafCode);
    if (nafEmoji) {
        return { name: nafCode!, logo: nafEmoji, isIcon: true };
    }

    // If no franchise logo found, check for restaurant type emoji fallbacks
    for (const [typeKeyword, emoji] of Object.entries(restaurantTypeEmojis)) {
        if (normalizedName.includes(typeKeyword)) {
            return {
                name: typeKeyword,
                logo: emoji,
                isIcon: true
            };
        }
    }

    return {
        name: 'restaurant',
        logo: '🍽️',
        isIcon: true
    };
};

/**
 * Gets the franchise logo if available
 * @param companyName - The company name to check
 * @param nafCode - Optional NAF code for activity-based emoji override
 * @returns The logo URL or icon identifier if franchise detected, null otherwise
 */
export const getFranchiseLogo = (companyName: string, nafCode?: string): { logo: string | React.ComponentType; isIcon?: boolean } => {
    const franchise = detectFranchise(companyName, nafCode);
    return { logo: franchise.logo, isIcon: franchise.isIcon };
};

/**
 * Only a real logo image shipped with the app, or null. `getFranchiseLogo` never returns nothing —
 * it falls back to an emoji — so code that must try other sources (back-office logo, Clearbit)
 * when there is no bundled image has to ask this instead.
 */
export const getBundledLogo = (companyName: string): string | null => {
    const match = detectFranchise(companyName);
    return match && !match.isIcon ? (match.logo as string) : null;
};
